export default __webpack_public_path__ + "packs/static/media/tone.127109e2.mp3";